module.exports = __webpack_public_path__ + "img/darkblue@2x.6dc8e790.png";